import React from 'react';
import styled, { keyframes } from 'styled-components';
import { position } from 'styled-system';
const spinner = keyframes `
  to {
    transform: rotate(360deg);
  }
`;
const Component = styled.i `
  animation: ${spinner} 0.6s linear infinite;
  border: 2px solid transparent;
  border-bottom: 2px solid
    ${({ color = 'white', theme }) => theme.colors[color]};
  border-radius: 50%;
  border-right: 2px solid ${({ color = 'white', theme }) => theme.colors[color]};
  border-top: 2px solid ${({ color = 'white', theme }) => theme.colors[color]};
  height: calc(1rem + 2px);
  position: absolute;
  width: calc(1rem + 2px);

  ${position};
`;
export const Spinner = props => (React.createElement(Component, { ...props, "aria-hidden": true }));
//# sourceMappingURL=index.js.map